export default __webpack_public_path__ + "static/media/1323.5e404a80.png";